import * as R from 'ramda';

const fieldsDict = {
  'customer.cpf': 'cpf',
  'customer.cnpj': 'cnpj',
  'customer.email': 'email',
  'customer.fullName': 'name',
  'customer.gender': 'gender',
  'customer.birthday': 'birthday',
  'type.pf.birthday': 'birthday',
  'phone.mainPhone.ddd': 'phone',
  'phone.mainPhone.number': 'phone',
  'phone.mobilePhone.number': 'cellphone',
  'customer.mobilePhone': 'cellphone',
  'customer.corporateName': 'corporateName',
  'customer.indicatorIERecipient': 'taxInfo',
  'customer.stateInscription': 'stateRegistry',
  'customer.fantasyName': 'fantasyName',
  'customer.representative': 'contactName',
  'address.recipientName': 'responsibleName',
  'address.zipCode': 'zipCode',
  'address.address': 'address',
  'address.number': 'number',
  'address.neighborhood': 'neighborhood',
  'address.city': 'city',
  'address.state': 'state',
  'address.reference': 'reference',
  'account.id': 'buyerEmail',
  'account.name': 'buyerName',
  'account.password': 'buyerPassword',
  'buyer.phone.mainPhone.ddd': 'buyerPhone',
  'buyer.phone.mainPhone.number': 'buyerPhone',
  'buyer.phone.mobilePhone.ddd': 'buyerCellphone',
  'buyer.phone.mobilePhone.number': 'buyerCellphone'
};

const customErrorMessages = {
  'customer.email': {
    REQUIRED: 'É necessário informar um e-mail.',
    INVALID: 'O email fornecido é inválido.'
  },
  'phone.mainPhone.ddd': { REQUIRED: 'É necessário informar o DDD do telefone principal.' },
  'phone.mainPhone.number': {
    REQUIRED: 'É necessário informar o número do telefone principal.',
    INVALID: 'Número inválido do telefone principal.'
  },
  'customer.corporateName': {
    REQUIRED: 'É necessário informar a razão social.',
    EXACT_LENGTH: 'A razão social precisa ter entre 3 e 60 caracteres.'
  },
  'customer.cnpj': { INVALID: 'CNPJ inválido.' },
  'customer.cpf': { INVALID: 'CPF inválido.' },
  'customer.indicatorIERecipient': { REQUIRED: 'Obrigatório envio da informação tributária.' },
  'customer.stateInscription': {
    REQUIRED: 'É necessário informar a inscrição estadual.',
    INVALID: 'Número de inscrição estadual inválido.'
  },
  'customer.fantasyName': {
    REQUIRED: 'É necessário informar o nome fantasia.',
    EXACT_LENGTH: 'A nome fantasia precisa ter entre 3 e 60 caracteres.'
  },
  'customer.representative': {
    REQUIRED: 'Atenção! Insira nome e sobrenome.',
    EXACT_LENGTH: 'Nome do contato precisa ter entre 3 e 60 caracteres.'
  },
  'customer.fullName': {
    REQUIRED: 'Por favor, informe o nome e o sobrenome.',
    INVALID: 'É necessário informar o nome e sobrenome.',
    EXACT_LENGTH: 'Nome precisa ter entre 3 e 60 caracteres.'
  },
  'customer.birthday': {
    REQUIRED: 'É necessário informar a data de nascimento.',
    BUSINESS: 'Não é possível criar um cadastro com menos de 18 anos.'
  },
  'customer.gender': { INVALID: 'Selecione uma opção.' },
  'buyer.phone.mainPhone.ddd': { REQUIRED: 'É necessário informar o DDD do telefone principal.' },
  'buyer.phone.mainPhone.number': {
    REQUIRED: 'É necessário informar o número do celular.',
    INVALID: 'Número inválido.'
  },
  'buyer.phone.mobilePhone.ddd': { REQUIRED: 'É necessário informar o DDD.' },
  'buyer.phone.mobilePhone.number': {
    REQUIRED: 'É necessário informar o número.',
    INVALID: 'Número inválido.'
  },
  'account.name': { REQUIRED: 'É necessário informar o nome do comprador.' },
  'account.password': { EXACT_LENGTH: 'Senha precisa ter entre 6 a 50 caracteres.' },
  'account.id': {
    REQUIRED: 'É necessário informar o email de login do comprador.',
    EXACT_LENGTH: 'Email de login fornecido é inválido.'
  },
  'address.address': { REQUIRED: 'É necessário informar o nome da rua.' },
  'address.number': {
    REQUIRED: 'Campo número está vazio.',
    MAX_LENGTH: 'O número tem que ter no máximo 5 caracteres.'
  },
  'address.neighborhood': { REQUIRED: 'É necessário informar o bairro.' },
  'address.city': { REQUIRED: 'É necessário informar a cidade.' },
  'address.state': { REQUIRED: 'É necessário informar o estado.' },
  'address.zipCode': { REQUIRED: 'É necessário informar o CEP.' },
  'address.recipientName': { REQUIRED: 'Atenção! Insira nome e sobrenome.' }
};

const defaultErrorMessages = {
  BLANK: 'Campo obrigatório',
  INVALID: 'Campo inválido',
  REQUIRED: 'Campo obrigatório',
  BUSINESS: 'Campo inválido',
  EXACT_LENGTH: 'O campo precisa ter entre 3 e 60 caracteres.'
};

const getFormFieldName = error => {
  const fieldName = R.propOr('', 'fieldName', error);
  const formFieldName = fieldsDict[fieldName];

  return formFieldName;
};

const getErrorMessage = error => {
  const errorType = R.propOr('', 'restrictionType', error);
  const defaultErrorMessage = R.propOr('', errorType, defaultErrorMessages);
  const fieldName = R.propOr('', 'fieldName', error);
  const errorMessage = R.pathOr(defaultErrorMessage, [fieldName, errorType], customErrorMessages);

  return errorMessage;
};

export default errors =>
  (errors || []).reduce(
    (acc, error) => ({
      ...acc,
      [getFormFieldName(error)]: getErrorMessage(error)
    }),
    {}
  );
